import React = require('react');
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { destroy, reset } from 'redux-form';
import { mtaActions } from '../../../../../../services/mta/actions';
import { withJob } from 'react-jobs';
import { actions as brandingActions } from '../../../../../../services/branding/reducer';
import { IAuthState } from '../../../../../../services/auth/models';
import { IBrandingActions, IBrandingState } from '../../../../../../services/branding/models';
import { IMtaActions, IMtaState } from '../../../../../../services/mta/models';
import { ICustomerMTAOptions } from '../../index';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner';
import { useEffect, useState } from 'react';
import { checkIfAllOptionsAreAdded, resetForms, setSelectedPolicy } from '../MakeAChangeSelection/MTAHelpers';
import { RedirectCommon } from '../RedirectCommon';
import { MtaSelection } from '../MakeAChangeSelection';
import { paymentMethodActions } from '../../../../../../services/paymentMethod/actions';
import { IPaymentMethodActions } from '../../../../../../services/paymentMethod/models';
import * as api from '../../../../../../data/api/api';
import { IPolicyClaims } from '../../../../../../data/api/models';

interface IMakeAChangeProps {
  auth: IAuthState;
  branding: IBrandingState;
  mta: IMtaState;
  customerMTAOptions: ICustomerMTAOptions;
  match: any;
  actions: {
    push(path: string);
    reset(formName: string);
    destroy(formName: string);
    mta: IMtaActions;
    branding: IBrandingActions;
    paymentMethod: IPaymentMethodActions;
  };
}


const RedirectToMtaAdditional = ({ auth, match, mta, actions, customerMTAOptions }: IMakeAChangeProps) => {

  const policyId = match.params.id;
  const [allowedMta, setAllowedMta] = useState(true);
  const [loading, setLoading] = useState(true);
  const allOptionsAdded = checkIfAllOptionsAreAdded(mta);
  const enabled = get(customerMTAOptions, 'additional_options.enabled', false);

  const handleSetLoading = () => {
    setLoading(false);
  };

  useEffect(() => {
    resetForms(actions);
    const promises = [];
    const track = true;
    const checkWSExclusion = true;
    promises.push(api.getCustomerRateableClaims())
    promises.push(actions.mta.setUpsellRules(false));
    Promise.all(promises).then((results) => {
      // Retrieve the claims from getCustomerRateableClaims.
      const claims = results[0]
      // Find any claims related to this policy
      const policyClaims = claims.filter((claim: IPolicyClaims) => claim?.attributes?.policy_id === match.params.id)

      policyClaims.forEach((claim: IPolicyClaims) => {
        // Open claims will prevent all MTA.
        if (get(claim, 'id', null) !== null && get(claim, 'attributes.claim_status') === 'open') {
          setAllowedMta(false)
          setLoading(false);
          // If any are open, we can exit here with MTA disabled
          return;
        }
      })

      setSelectedPolicy({
        policyId,
        auth,
        actions,
        mta,
        callback: handleSetLoading,
        customerMTAOptions,
        track,
        checkWSExclusion,
      });
    }).catch(() => {
      setLoading(false);
    });

  }, [])

  if (loading) {
    return (
      <LoadingSpinner text={'Getting your policy details...'}/>
    )
  }

  if (allOptionsAdded || !enabled) {
    actions.push('account/summary')
  }


  if (!allowedMta && !loading) {
    return RedirectCommon.renderNotAllowedMTAStatic()
  }

  if (!loading && allowedMta) {
    Promise.resolve(actions.mta.setSelectedMTAChange(MtaSelection.ADDITIONAL_OPTION)).then(() => {
      actions.push(`/account/make-a-change/cover-details/${policyId}`);
    })
  }

  return null;
}

export default flow([
  withJob({
    work: (props: IMakeAChangeProps) => {
      const promises = [];

      promises.push(props.actions.branding.reLoadChannel(props.branding.defaultChannelKey));

      return Promise.all(promises);
    },
    LoadingComponent: () => <LoadingSpinner text={'Getting your policy details...'}/>,
    ErrorComponent: ({ error }) => {

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        mta: state.mta,
        branding: state.branding,
        customerMTAOptions: get(state.branding.channel.products[0], 'metadata.direct_customer_mta_options', null),
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      },
    }),
  ),
])(RedirectToMtaAdditional);
